import { useState, useCallback, useEffect } from 'react';
import qs from 'query-string';

const { history, location } = window;

function setQueryString(qsValue) {
  const newUrl = `${location.protocol}//${location.host}${location.pathname}${qsValue}`;
  history.pushState({}, '', newUrl);
}

export function setQueryStringValue(key, value) {
  const queryString = location.search;
  const values = { ...qs.parse(queryString), [key]: value };

  const filteredValues = Object.entries(values).length
    ? Object.entries(values).filter(([, v]) => v)
    : [];
  const newValue = Object.fromEntries(filteredValues);

  const newQsValue = qs.stringify(newValue, {
    arrayFormat: 'comma'
  });
  setQueryString(newQsValue ? `?${newQsValue}` : '');
}

export function getQueryStringValue(key) {
  const queryString = location.search;
  const values = qs.parse(queryString, { arrayFormat: 'comma' });

  return values[key];
}

export function useQueryString(key, initialValue = '') {
  const [value, setValue] = useState(getQueryStringValue(key) || initialValue);
  const onSetValue = useCallback(
    (newValue) => {
      setValue(newValue);
      setQueryStringValue(key, newValue);
    },
    [key]
  );

  useEffect(() => {
    const handlePopState = () => setValue(getQueryStringValue(key));
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [key, onSetValue]);

  return [value, onSetValue];
}
